<template>
  <div class=" is-fullwidth">
    <div class="card">
          <div class="card-content">
                <div class="field">
                    <label class="label">PO Number</label>
                    <div class="control">
                        <input class="input" type="text" v-model="ponumber" ref="ponumber" autofocus>
                    </div>
                </div>

                <div class="field ">
                    <div class="control">
                        <button class="button is-success" @click="viewOrder()">Search</button>
                    </div>
                    
                </div>
            </div>
    </div>
    <br /> 
    
    <div class="columns">
        <div class="column is-two-thirds">
            <div class="card ">
            <div class="card-content">
                    <div class="notification is-info" v-if="order.orderID == 0 && loading == false">
                    Enter a PO Number above to search for an order
                    </div>
                
                    <div class="notification is-warning" v-if="loading == true">
                    Seaching for your order ...
                    </div>

                    <div class="" v-if="order.orderID > 0 && loading == false">
                    <div class="field">
                        <label class="label">PO Number</label>
                            <div class="columns">
                                <div class="control column">
                                    <input class="input" type="text" v-model="order.ponumber" readonly disabled>
                                </div>
                                <div class=" column">
                                    <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-warning">Print Order</button></a>
                                </div>
                                <div class="column">
                                    <form :action="ASP_URL + '/createpdforder-internal.php'" method="POST" target="_blank">
                                        <input type="hidden" name="txtPONumber" :value="order.ponumber" />
                                        <input type="hidden" name="MODE" value="VIEW" />
                                        <input type="submit" class="button is-success" value="Save PDF">
                                    </form>
                                </div>
                               
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Required Delivery Date</label>
                            <div class="control">
                                <input class="input" type="text" v-model="order.deliverydate" readonly disabled>
                            </div>
                        </div>
                        
                        <div v-if="user.user_ireland==1">
                            <div class="field">
                                <label class="label">Digital Print Locations</label>
                            </div>

                            <div class="field">
                                <div class="is-flex is-align-items-center">
                                    <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Paper Print Location</label>
                                    <div class="control">
                                        <div class="buttons has-addons">
                                            <button class="button is-small" @click="updatePrintLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field">
                                <div class="is-flex is-align-items-center">
                                    <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Fabric Rolls Location</label>
                                    <div class="control">
                                        <div class="buttons has-addons">
                                            <button class="button is-small" @click="updateFabricRollsLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.fabric_print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field">
                                <div class="is-flex is-align-items-center">
                                    <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Gerber Cutting Location</label>
                                    <div class="control">
                                        <div class="buttons has-addons">
                                            <button class="button is-small" @click="updateGerberCuttingLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.gerber_print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field mt-6">
                            <label class="label">Printing/Cutting Logs</label>
                            <div class="control content">
                                <div v-if="order.printing_saves.length > 0">
                                    <p  class="has-text-success">Saving complete</p>
                                    <ul  class="" style="margin-bottom:1em">
                                        <li v-for="row in order.printing_saves" :key="row.id">{{ row.date}} - {{ row.user_forename}} {{ row.user_surname}} - {{ showSaveStatus(row.status) }}</li>
                                    </ul>
                                
                                </div>
                                <div v-else>
                                    <p  class="has-text-danger" style="margin-bottom:1em">Saving not complete</p>
                                </div>
                                
                                
                                <p v-if="order.artwork_printed_paper == 1" class="has-text-success">Printing on paper complete</p>
                                <p v-if="order.artwork_printed_paper == 0" class="has-text-danger">Printing on paper not complete</p>
                                <ul v-if="order.printing_papers.length > 0" class="">
                                    <li v-for="row in order.printing_papers" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                                </ul>
                                <p v-if="order.artwork_printed_rolls == 1" class="has-text-success">Transmatic process complete</p><p v-if="order.artwork_printed_rolls == 0" class="has-text-danger">Transmatic process not complete</p>
                                <ul v-if="order.printing_rolls.length > 0" class="">
                                    <li v-for="row in order.printing_rolls" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                                </ul>
                                <p v-if="order.digital_print_cutting == 1" class="has-text-success">Gerber cutting complete</p><p v-if="order.digital_print_cutting == 0" class="has-text-danger">Gerber cutting not complete</p>
                                <ul v-if="order.cuttings.length > 0" class="">
                                    <li v-for="row in order.cuttings" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                                </ul>
                                <p v-if="order.ready_for_makeup == 1" class="has-text-success">Processed for makeup - <a :href="'/printing-cutting/bundling/' + order.orderID" target="_blank">Re-print barcodes</a></p><p v-if="order.ready_for_makeup == 0" class="has-text-danger">Not yet Processed for makeup</p>
                            </div>
                        </div>
                        <div class="field mt-6">
                            <label class="label">Makeup Location</label>
                            <div class="control">
                                <div class="buttons has-addons ">
                                    <button class="button is-small " @click="showAlert('Clicking on this does nothing')" :disabled="working==true" :class="{'is-success' : order.makeup_location_id==row.id}"  v-for="row in makeuplocations" :key="row.id">{{ row.name }}</button>
                                </div>
                            </div>
                        </div>

                        
                    
                    </div>

                    
                    
                </div>
            </div>
        </div>
        
        <div class="column is-one-third">
            <div class="card " v-if="order.orderID > 0 && task_allowed('update_fabric') ">
                <div class="card-content">
                    <div class="field">
                        <label class="label">Fabric</label>
                        <div class="control">
                            <select class="select input" v-model="fabric_id" required>
                                    <option value="">Please select</option>
                                    <option v-for="row in fabrics" :value="row.id" :key="row.id">{{ row.name}}</option>
                                </select>
                        </div>
                    </div>

                    <div class="field">
                       <div class="control">
                            <div class="buttons has-addons ">
                                <button class="button is-success " @click="updateDesignFabric()" :disabled="working==true" >Update Fabric for CAD Design</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end of columns-->
    <br />
    <div class="card " v-if="order.orderID > 0 && loading == false">
          <div class="card-content">
              <table class="table is-fullwidth" v-if="order.logs.length > 0">
                  <thead>
                    <tr>
                            <th>Action</th>
                            <th>User (Who Peformed the Action)</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in order.logs" :key="row.id">
                            <td>{{ row.text }}</td>
                            <td>{{ row.firstname }} {{row.surname}}</td>
                            <td>{{ row.date }}</td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
    </div>
    <br />
    
    
  </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      order: {orderID: 0},
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading:false,
      locations: [],
      makeuplocations: [],
      ponumber: '',
      ASP_URL : process.env.VUE_APP_ASP_URL,
      fabrics: [],
      fabric_id: '',
      user: {tasks: []},
     
    }
  },
   methods: {
        showAlert(alertText){
            alert(alertText)
        },
        updateDesignFabric() {
           
            this.working = true
            var formdata = { 
                _method: 'patch',
                fabric_id: this.fabric_id
            }

            OrderService.updateDesign(this.accessToken, this.order.designID, formdata)
            .then(() => {
                this.working = false
                this.viewOrder()
                //console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
        },
      async viewOrder() {
        if(this.ponumber != '' && this.ponumber != null)
        {
          this.loading=true
          OrderService.getOrderByPONumber(this.accessToken, this.ponumber, "", 1) // Last one is to get all logs back
          .then(
            (orders => {
                if(orders.length > 0)
                {
                      this.$set(this, "order", orders[0]);
                      this.fabric_id = this.order.fabric_id
                }
              this.loading=false
            }).bind(this)
          );
        }
      },
      focusInput() {
          this.$nextTick(() => this.$refs.ponumber.focus())
      },
      getPONumber() {
        let urlParams = new URLSearchParams(window.location.search);
        let urlPONumber = urlParams.get('ponumber');
        this.ponumber = urlPONumber

        this.viewOrder()
      },
      async getFabrics() {
        UtilityService.getSimpleApiData(this.accessToken, "fabrics").then(
               response => this.fabrics = response 
            );
      },
      
    
    
  },
  computed : {
     
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getPrintLocations();
           this.getMakeupLocations();
           this.getFabrics();

           this.getUserProfile(1); // 1 for with_tasks

           this.focusInput()
            

           if(this.$route.params.id != "" && this.$route.params.id != undefined)
           {
             this.ponumber = this.$route.params.id
            this.viewOrder()
            
           }
           else
           {
            this.getPONumber()
           }
        });
  },
 
  mounted() {
   
     
  },
  watch: {
    '$route'() {
      
    },
    
  }
}


</script>

